// eslint-disable-next-line import/no-unassigned-import
import 'whatwg-fetch';
import React from 'react';

import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import Root from './Root';
import i18n from './i18n/i18n';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.getElementById('root')!);
root.render(
  <I18nextProvider i18n={i18n}>
    <Root />
  </I18nextProvider>,
);
